import React from 'react';
import { StyledDashboardHeader } from '../../style/DashboardHeader';

const DashboardHeader = ({ title }) => {
  return (
    <StyledDashboardHeader>
      <h1>{title}</h1>
    </StyledDashboardHeader>
  );
};

export default DashboardHeader; 